import { createColumnHelper } from '@tanstack/react-table'
import { format } from 'date-fns'
import { Transaction } from '../../../../../app/entities/Transaction'
import { formatMoneyValue } from '../../../../../app/utils/formatMoneyValue'
import { BasicAvatar } from '../../../../components/BasicAvatar'
import Status from '../../../../components/Status'
import { formatName } from '@/app/utils/formatName'
import { getImageByType } from '@/app/utils/getImageByType'

const columnHelper = createColumnHelper<Transaction>()

const columnsCustomerTransactions = [
  columnHelper.accessor('contract', {
    id: 'contract',
    header: () => (
      <div className="flex flex-col items-start gap-1 pl-2">
        <div>Contrato</div>
        <div className="block text-black04 xl:hidden">Vendedor</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-start gap-1 pl-4 ">
        <div>
          {String(row.original.contract).length !== 24
            ? row.original.contract
            : "-"}
        </div>
        <div className="block text-black04 xl:hidden">
          <div className="flex flex-col gap-1">
            <p className="text-black04">
              {formatName(row.original.seller.name)}
            </p>
            <p className="text-black04">{row.original.team?.name}</p>
          </div>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('type', {
    id: 'type',
    header: () => <div className="hidden pl-2 text-left xs:block">Produto</div>,
    cell: ({ row }) => {
      const type = row.original.type
      const imageSrc = getImageByType(type)

      return (
        <div className="hidden items-center justify-start pl-6 text-left xs:flex">
          <img
            src={imageSrc}
            className="mb-1 h-8 w-8 rounded-lg object-contain"
            alt={type}
          />
        </div>
      )
    },
  }),
  columnHelper.accessor('seller', {
    id: 'seller',
    header: () => <div className="hidden text-start xl:block">Vendedor</div>,
    cell: ({ row }) => (
      <div className="hidden text-start xl:block">
        <div className="flex items-center gap-2">
          <BasicAvatar
            name={row.original.seller.name}
            profileImageUrl={row.original.seller.profileImageUrl}
          />
          <div className="flex flex-col gap-1">
            <p>{formatName(row.original.seller.name)}</p>
            <p className="text-black04">{row.original.team?.name}</p>
          </div>
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('value', {
    id: 'value',
    header: () => (
      <div className="flex flex-col items-end pr-2 lg:items-center lg:pr-0">
        <div>Valor</div>
        <div className="block text-black04 lg:hidden">Data</div>
        <div className="block text-black04 xl:hidden">Status</div>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex flex-col items-end gap-1 pr-4 lg:items-center lg:pr-0">
        <div>{formatMoneyValue(row.original.value)}</div>
        <div className="block xl:hidden">
          <Status status={row.getValue('actualStatus')} />
        </div>
        <div className="block lg:hidden">
          {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
        </div>
      </div>
    ),
  }),
  columnHelper.accessor('createdAt', {
    id: 'data',
    header: () => <div className="hidden lg:block">Data</div>,
    cell: ({ row }) => (
      <div className="hidden lg:block">
        {format(row.original.createdAt, 'dd/MM/yyyy, HH:mm')}
      </div>
    ),
  }),
  columnHelper.accessor('actualStatus', {
    id: 'actualStatus',
    header: () => (
      <div className="flex items-center justify-end">
        <div className="hidden pr-0 xl:block xl:pr-2">Status</div>
      </div>
    ),
    cell: ({ row }) => {
      return (
        <div className="hidden xl:block">
          <div className="flex items-center justify-end pr-4">
            <Status status={row.getValue('actualStatus')} />
          </div>
        </div>
      )
    },
  }),
]

export const ColumnDefinitionCustomerTransaction = () => {
  return {
    columnsCustomerTransactions,
  }
}
